module.exports = __webpack_public_path__ + "static/cliente_9-ea60e99de267adc682ea656772fef3e6.png";